import { render, staticRenderFns } from "./role-user-config.vue?vue&type=template&id=3f6663c4&"
import script from "./role-user-config.vue?vue&type=script&lang=js&"
export * from "./role-user-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports